import { RightCircleOutlined } from "@ant-design/icons";
import React from "react";
import styled from "styled-components";

// todo: convert to presentational component
const LineFolder = ({ categoryName, officeSlug, onClick, isDisabled }) => {
	return (
		<Folder
			onClick={isDisabled ? () => {} : onClick}
			isDisabled={isDisabled}
		>
			<UpperSection>
				<h3>{categoryName}</h3>
			</UpperSection>
			<LowerSection isDisabled={isDisabled}>
				<p>Ver filas de la carpeta</p>
				<RightCircleOutlined
					style={{
						color: isDisabled ? "#f0f0f0" : "#096DD9",
						fontSize: "16px",
					}}
				/>
			</LowerSection>
		</Folder>
	);
};

const Folder = styled.div`
	border: 1px solid #f0f0f0;
	box-shadow: 0px 4px 6px -4px rgba(24, 39, 75, 0.12),
		0px 8px 8px -4px rgba(24, 39, 75, 0.08);
	cursor: ${(props) => (props.isDisabled ? "not-allowed" : "pointer")};
	display: flex;
	flex-direction: column;
	justify-content: space-between;
	margin-bottom: 20px;
	height: 88px;
	width: 45%;

	@media (max-width: 767px) {
		width: 90vw;
		margin-bottom: 20px;
	}

	&:hover {
		border: ${(props) => (props.isDisabled ? "none" : "1px solid #9ac2ff")};
	}
`;

const UpperSection = styled.div`
	display: flex;
	align-items: center;
	justify-content: start;
	height: 65%;
	padding: 8px 16px 0;
	background-color: #fff;
	width: 100%;

	h3 {
		color: #000;
		font-size: 14px;
		font-weight: 500;
	}
`;

const LowerSection = styled.div`
	height: 35%;
	display: flex;
	align-items: center;
	justify-content: space-between;
	padding: 0 16px;
	background: #f6faff;
	border-radius: 0px 0px 2px 2px;
	width: 100%;

	p {
		margin: 0;
		font-family: "Montserrat";
		font-size: 13px;
		font-weight: 400;
		color: ${(props) => (props.isDisabled ? "#696969" : "#096dd9")};
	}
`;

export default LineFolder;
